import React, { Component } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core/styles'
// import './App.css';
import Routes from './routes'
// import { blue } from '@material-ui/core/colors'

const theme = createTheme({
    palette: {
        primary: {
            light: '#567ee7',
            main: '#0052b4',
            dark: '#002b83',
            contrastText: '#fff',
        },
        secondary: {
            light: '#fff',
            main: '#fff',
            dark: '#cccccc',
            contrastText: '#0052b4',
        },
        background: {
            default: '#E7EFF8'
        }
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '"Lato"',
            'sans-serif'
        ].join(',')
    },
});


class App extends Component {
    render() {
        return ( <
            ThemeProvider theme = { theme } >
            <
            Routes / >
            <
            /ThemeProvider>
        );
    }
}

export default App;